var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    'theme-grayscale-1': _vm.isBrightness === 1,
    'theme-grayscale-2': _vm.isBrightness === 2
  },attrs:{"light":""}},[_c('v-main',[_c('router-view')],1),_c('overlay-loading'),_c('snackbar',_vm._b({on:{"input":function($event){return _vm.onSnackbarChange($event)}}},'snackbar',_vm.snackbar,false)),_c('modal',_vm._b({on:{"onConfirm":function($event){return _vm.onDialogChange($event)},"onCancel":function($event){return _vm.onDialogChange($event)}}},'modal',_vm.confirmDialog,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }